module.exports = __webpack_public_path__ + "img/en_us1.fc5456b0.png";